import React from 'react';
import { WrapLayer } from '../styles';

const Layer = (props: any) => {
  const { handleClose } = props;
  return <WrapLayer onClick={handleClose} />;
};

export default Layer;
